import {
  NBS_API_RESEND_CONFIRMATION_EMAIL_REQUEST,
  NBS_API_RESEND_CONFIRMATION_EMAIL_SUCCESS,
  NBS_API_RESEND_CONFIRMATION_EMAIL_FAILURE,
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  response: {},
  status: null,
};

export default function confirmEmail(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_RESEND_CONFIRMATION_EMAIL_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        status: 'request',
      };
    case NBS_API_RESEND_CONFIRMATION_EMAIL_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        status: 'success',
      };
    case NBS_API_RESEND_CONFIRMATION_EMAIL_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        status: 'fail',
      };
    default:
      return state;
  }
}
